module.exports = __webpack_public_path__ + "static/media/oberflex-merisierdamerique-2560x1440.6b15b3e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-merisierdamerique-2560x1440.jpg
// module id = 1033
// module chunks = 37